/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import cx from 'classnames';
import azCommonStyles from '@/theme/globals.module.scss';
import styles from '@/components/Cart/CommonCounterPart/PreOrderQuantitySelector/styles.module.scss';

type MiniCartErrorProps = {
  overQuantity: boolean;
  touched: boolean;
  label: string;
};

export const MiniCartError = ({ overQuantity, touched, label }: MiniCartErrorProps) => {
  if (!overQuantity || !touched) {
    return null;
  }

  return (
    <div
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      data-testid="max-qty-reached-error"
      className={cx(azCommonStyles['az-caption'], styles.quantityAvailableError)}
    >
      {label}
    </div>
  );
};
